export default [
	{
		start: 0.05,
		end: 3,
		text: 'Continuez, Hiver. Les messages affluent.'
	}
]
